import { ChainInfo } from '@packages/web3-react-plus'

export function isWrappedNativeToken(tokenSymbol: string, chainInfo: ChainInfo) {
  return chainInfo.wrappedNativeToken.symbol.toUpperCase() === tokenSymbol.toUpperCase()
}
